import { BlankSlate, Box, Card, Confetti } from '@factorialco/deprecated-design-system'

export const Celebration: React.FC<{
  title: string
  description: string
}> = ({ title, description }) => {
  return (
    <Card>
      <Card.Content>
        <Box width="full">
          <BlankSlate illustration="fireworks" title={title} description={description}>
            <Box position="relative">
              <Confetti />
            </Box>
          </BlankSlate>
        </Box>
      </Card.Content>
    </Card>
  )
}
